import { useEffect, useState } from "react";
import { ColumnItem } from "../../../common/models/table";
import { ActionsKey } from "../../../common/models/Actions";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../common/components/Loader/Loader";
import { TitleHeader } from "../../../common/components/TitleHeader/TitleHeader";
import { LFTableV3 } from "../../../common/components/LFTable/LFTableV3";
import { CustomDrawer } from "../../../common/components/Drawer/CustomDrawer";
import { useGateOutListState, useGateOutStore } from "./store/_gateOutStore";
import { GateOutService } from "./store/_requests";
import { GateOutDetails } from "./components/GateOutDetails";
import { StatusTag } from "../../../common/components/Status/StatusTag";
import { CustomerRemovalControlStatusConstant } from "./core/_constant.gateOut";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { FaFileAlt } from "react-icons/fa";
import { downloadPDF } from "../../../utilities/downloadPdf";
import { Filters } from "../components/Filters";
import { API_URLs } from "../../../utilities/API_URLs";
import { MdDownload } from "react-icons/md";
import { getIdFromIri, getRowId } from "../../../common/utils/iri";

export const GateOut = () => {

  const {
    setGateOutList,
    gateOutList,
    actioned,
    totalItems,
    setActioned,
  } = useGateOutStore();
  const { pageState, setPageState, resetPageState } =
    useGateOutListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [downloadingId, setDownloadingId] = useState<string | null>(null);

  const cols: ColumnItem[] = [
    {
      key: "reference",
      title: "Référence",
      dataIndex: "reference",
      // searchType: "text",
      show: true,
    },
    {
      key: "uniqueIdentifierLoad",
      title: "N° Conteneur",
      dataIndex: "uniqueIdentifierLoad",
      // searchKey: "uniqueIdentifierLoad",
      // searchType: "text",
      show: true,
    },
    {
      key: "bookingReference",
      title: "N° Booking",
      dataIndex: "bookingReference",
      searchKey: "booking.reference",
      searchType: "text",
      show: true,
    },
    {
      key: "bookingBlNumber",
      title: "N° BL",
      dataIndex: "bookingBlNumber",
      searchKey: "booking.blNumber",
      searchType: "text",
      show: true,
    },
    {
      key: "customer",
      title: "Transitaire",
      dataIndex: "customer",
      searchKey: "customer.name",
      show: true,
      render: (state: any) => state.name
    },

    {
      key: "finalCustomer",
      title: "Client",
      dataIndex: "finalCustomer",
      searchKey: "finalCustomer",
      show: true,
    },
    {
      key: "truck",
      title: "Camion",
      dataIndex: "truck",
      nestedKey: "truck.reference",
      show: true,
      render: (truck: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{truck?.reference}</span>
          </div>
        );
      },
    },
    {
      key: "deliveryDate",
      title: "Date de livraison",
      dataIndex: "deliveryDate",
      show: true,
    },
    {
      key: "state",
      title: "Statut",
      dataIndex: "state",
      nestedKey: "state.name",
      //searchType: "select",
      show: true,
      render: (state: any) => {
        return (
          <StatusTag
            value={state?.id}
            options={CustomerRemovalControlStatusConstant.OPTIONS}
          />
        );
      },
    },
    {
      key: "containerRestitutionDelay",
      title: "Délai de restitution",
      dataIndex: "containerRestitutionDelay",
      nestedKey: "containerRestitutionDelay.label",
      show: true,
      render: (delay: any) => {
        return (
          <div className="h-100 w-100 d-flex align-items-center justify-content-center">
            <span>{delay?.label}</span>
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    fetchAllGateOut(pageState);
  }, [pageState]);

  const onActionClick = async (item: any, action: ActionsKey) => {
        try {
          setIsLoading(true);
      
          const res = await GateOutService.getGateOutById(item?.id);
      
          if (res?.status === HttpStatusCode.Ok) {
            setActioned({
              data: {
                ...res?.data,
              },
              action,
            });
      
            setIsShowForm(true);
          }
        } catch (error) {
          console.log(error);
        } finally {
          setIsLoading(false);
        }
      };

  const handleCloseDrawer = () => {
    setIsShowForm(false);
  };


  const fetchAllGateOut = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await GateOutService.getGateOutList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setGateOutList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  const onClickOnExitPermit = async (action: any) => {
    const rowData = action.row;
    try {
      const idPdf = rowData?.storageLoad.loadId
      const rowId = rowData?.["@id"]
      ? rowData["@id"].split("/").pop()
      : rowData?.id;
        setDownloadingId(rowId);
       // await downloadPDF(`/api/customer_removal_controls/${idPdf}/bon_sortie/pdf`);
       await downloadPDF(`/api/container_loads/${idPdf}/EIR/pdf`);
    } catch (error) {
      console.log(error)
    } finally {
      setDownloadingId(null);
    }
  }

  const onClickExitNote = async (action: any) => {
    const rowData = action.row;
  
    const contentUrl = rowData?.exitNoteFile?.contentUrl;
    const basename = rowData?.exitNoteFile?.basename;
    const rowId = getRowId(rowData);
  
    if (!contentUrl) return;
  
    const fileName =
      basename?.split("?")[0] ||
      "bon-de-sortie.pdf";
  
    try {
      setDownloadingId(rowId);
  
      await downloadPDF(contentUrl, fileName);
    } catch (error) {
      console.error(error);
    } finally {
      setDownloadingId(null);
    }
  };

  return (
    <div className="">
      <Loader isLoading={isLoading} />
      <TitleHeader
        title="Enlèvement client (Gate Out)"
      />
      <Filters
        uri={API_URLs.customerRemovalControl.customerRemovalControlStatesForFilters}
        //filterKey="restitutionSource"
        params={pageState}
        initialParams={{
          page: 1,
          itemsPerPage: 10,
          pagination: true,
        }}
        onChange={handleSetParams}
        getParams={(option) => ({
          "exists[restitutionControl]":
            option.id === "RETURNED",
        })}
      />
      <div className="mt-4">
        {/* Table section  */}
        <div className="">
          <LFTableV3
            columns={cols}
            data={gateOutList}
            params={pageState}
            onAction={onActionClick}
            isCanShow={() => true}
            onSearch={handleSetParams}
            //onSort={handleSetParams}
            onResetSearch={resetPageState}
            pagination={{
              defaultCurrentPage: pageState.page,
              itemsPerPage: pageState?.itemsPerPage,
              totalItems: totalItems,
            }}
            onChangePage={handleSetParams}
            otherActions={[
              (rowAction ) => {
                const rowData = rowAction.row;
              const rowId = rowData?.["@id"]?.split("/").pop() || rowData?.id;
                return(
                <>
                  <div>
                    { 
                    downloadingId === rowId ? (
                      <Spin
                        indicator={<LoadingOutlined spin />}
                        size="small"
                      />
                    ) : (
                    <div
                      className=" cursor-pointer"
                      onClick={() => {
                        onClickOnExitPermit(rowAction);
                      }}
                    >
                      <MdDownload title={"Télécharger EIR"}/>
                    </div>
                    )} 
                  </div>
                </>
                )
              },
              (rowAction) => {
                const rowData = rowAction.row;
                const exitNoteId = getIdFromIri(rowData?.exitNoteFile?.["@id"]);
                const rowId = getRowId(rowData);

                if (!exitNoteId) {
                  return;
                }

                return (
                      <div
                        className=" cursor-pointer"
                        onClick={() => {
                          onClickExitNote(rowAction);
                        }}
                      >
                        <FaFileAlt title={"Voir le bon de sortie"} />
                      </div>
                );
              },
            ]}
          />
        </div>
      </div>

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={handleCloseDrawer}
          title={"Détails"}
          width={"75%"}
        >
          <GateOutDetails value={actioned?.data}/>
        </CustomDrawer>
      ) : (
        ""
      )}
    </div>
  );
};
